// DL1.40 User object
export async function dataLayerUserInfo(cardId: string, memberId: string) {
    if (!cardId || !memberId) return;

    dataLayer.push({
        user: {
            cardId: cardId,
            memberId: memberId,
        },
    });
}

// DL2.20 Registration form
export function dataLayerRegistrationPersonal() {
    dataLayer.push({
        page: {
            type: "sazkaklub.account.registration",
            kind: "sazkaklub.account.registration",
            verticalCode: "sazkaklub",
            verticalCodeStrict: "sazkaklub",
            gameCode: "no_game",
            gameCodeStrict: "no_game",
        },
        event: "page",
    });
}

// DL2.30 Login second step
export function dataLayerLoginSecondStep() {
    dataLayer.push({
        page: {
            type: "sazkaklub.account.login.password",
            kind: "sazkaklub.account.login.password",
            verticalCode: "sazkaklub",
            verticalCodeStrict: "sazkaklub",
            gameCode: "no_game",
            gameCodeStrict: "no_game",
        },
        event: "page",
    });
}

// DEPRECATED
// DL2.31 Password is not set page
// popup for this event doens't exist
// export function dataLayerPasswordNotSet() {
//     dataLayer.push({
//         page: {
//             type: "sazkaklub.account.passwordNotSet",
//             kind: "sazkaklub.account.passwordNotSet",
//             verticalCode: "sazkaklub",
//             verticalCodeStrict: "sazkaklub",
//             gameCode: "no_game",
//             gameCodeStrict: "no_game",
//         },
//         event: "page",
//     });
// }

// DL2.40 Verify phone number page
export function dataLayerVerifyPhone() {
    dataLayer.push({
        page: {
            type: "sazkaklub.account.verifyPhone",
            kind: "sazkaklub.account.verifyPhone",
            verticalCode: "sazkaklub",
            verticalCodeStrict: "sazkaklub",
            gameCode: "no_game",
            gameCodeStrict: "no_game",
        },
        event: "page",
    });
}

// DL2.41 Verify SMS code page
export function dataLayerRegistrationCode() {
    dataLayer.push({
        page: {
            type: "sazkaklub.account.verifyPhone.SMScode",
            kind: "sazkaklub.account.verifyPhone.SMScode",
            verticalCode: "sazkaklub",
            verticalCodeStrict: "sazkaklub",
            gameCode: "no_game",
            gameCodeStrict: "no_game",
        },
        event: "page",
    });
}

// DL2.42 Verify phone confirmed page
export function dataLayerRegistrationCodeConfirmed() {
    dataLayer.push({
        page: {
            type: "sazkaklub.account.verifyPhone.confirmed",
            kind: "sazkaklub.account.verifyPhone.confirmed",
            verticalCode: "sazkaklub",
            verticalCodeStrict: "sazkaklub",
            gameCode: "no_game",
            gameCodeStrict: "no_game",
        },
        event: "page",
    });
}

// DEPRECATED
// DL2.50 Verify email page
// export function dataLayerRegistrationMail() {
//     dataLayer.push({
//         page: {
//             type: "sazkaklub.account.verifyEmail",
//             kind: "sazkaklub.account.verifyEmail",
//             verticalCode: "sazkaklub",
//             verticalCodeStrict: "sazkaklub",
//             gameCode: "no_game",
//             gameCodeStrict: "no_game",
//         },
//         event: "page",
//     });
// }

// DEPRECATED
// DL2.51 Verify email link confirm
// export function dataLayerRegistrationMailConfirmed() {
//     dataLayer.push({
//         page: {
//             type: "sazkaklub.account.verifyEmail.confirmed",
//             kind: "sazkaklub.account.verifyEmail.confirmed",
//             verticalCode: "sazkaklub",
//             verticalCodeStrict: "sazkaklub",
//             gameCode: "no_game",
//             gameCodeStrict: "no_game",
//         },
//         event: "page",
//     });
// }

// DL2.52 Verify email link expired
export function dataLayerRegistrationMailExpired() {
    dataLayer.push({
        page: {
            type: "sazkaklub.account.verifyEmail.linkExpired",
            kind: "sazkaklub.account.verifyEmail.linkExpired",
            verticalCode: "sazkaklub",
            verticalCodeStrict: "sazkaklub",
            gameCode: "no_game",
            gameCodeStrict: "no_game",
        },
        event: "page",
    });
}

// DEPRECATED
// DL2.60 Password was sent to user
// export function dataLayerRegistrationPasswordSent() {
//     dataLayer.push({
//         page: {
//             type: "sazkaklub.account.password.sent",
//             kind: "sazkaklub.account.password.sent",
//             verticalCode: "sazkaklub",
//             verticalCodeStrict: "sazkaklub",
//             gameCode: "no_game",
//             gameCodeStrict: "no_game",
//         },
//         event: "page",
//     });
// }

// DL2.61 Page where user is creating his password
export function dataLayerRegistrationPasswordCreation() {
    dataLayer.push({
        page: {
            type: "sazkaklub.account.password.setup",
            kind: "sazkaklub.account.password.setup",
            verticalCode: "sazkaklub",
            verticalCodeStrict: "sazkaklub",
            gameCode: "no_game",
            gameCodeStrict: "no_game",
        },
        event: "page",
    });
}

// DL2.62 Page where registration is finished
export function dataLayerRegistrationFinished() {
    dataLayer.push({
        page: {
            type: "sazkaklub.account.thankYou",
            kind: "sazkaklub.account.thankYou",
            verticalCode: "sazkaklub",
            verticalCodeStrict: "sazkaklub",
            gameCode: "no_game",
            gameCodeStrict: "no_game",
        },
        event: "page",
    });
}
